import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import RoomsLayout from './components/pages/Rooms';
import BedSpace from './components/pages/BedSpace';
import CouplePage from './components/CouplePage';
import PoloPage from './components/PoloPage';
import LoopPage from './components/LoopPage';

function App() {
  return (
    <Router>
      <NavigationBar />
      <div className="mt-5">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/rooms' element={<RoomsLayout />} />
          <Route path='/bedSpace' element={<BedSpace/>} />
          <Route path='/couple' element={<CouplePage/>} />
          <Route path='/polo' element={<PoloPage/>} />
          <Route path='/loop' element={<LoopPage/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
